module.exports = __webpack_public_path__ + "img/plan-02.31a58bb0.png";